































import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';

import { WhatsAppChannel, whatsappChannels } from '@/config/whatsappChannels';

@Component
export default class GetNotifiedDialog extends Vue {
  @State getNotifiedDialog!: boolean;
  @State siteLanguage!: string;
  @Mutation setGetNotifiedDialog!: (value: boolean) => void;

  get dialog() {
    return this.getNotifiedDialog;
  }

  set dialog(value: boolean) {
    this.setGetNotifiedDialog(value);
  }

  get channel(): WhatsAppChannel | undefined {
    return whatsappChannels[this.siteLanguage];
  }
}
